/**
 * Created by spepa on 18.12.2024
 */

var TelegramSocial = function () {
    Social.call(this, connector.TELEGRAM, {
        sdk: SdkManager.SDK_TELEGRAM
    });
};

TelegramSocial.prototype = Object.create(Social.prototype);
TelegramSocial.prototype.constructor = TelegramSocial;

TelegramSocial.prototype._connect = function (callback) {
    this.user = TelegramSocial.formatUserData(window.Telegram.WebApp.initDataUnsafe.user);
    callback(connector.STATUS_CONNECTED);
};

TelegramSocial.prototype.isLoggedIn = function () {
    return true;
};

TelegramSocial.prototype.isShareSupported = function () {
    return true;
};

TelegramSocial.prototype.share = function (data, callback) {
    // TODO: shareMessage + savePreparedInlineMessage({this.user.id, data.text, allow_user_chats});
    var bot = connector.config.telegram.botName;
    window.Telegram.WebApp.openTelegramLink("https://t.me/share/url?url=https://t.me/" + bot + "?startapp&text=" + data.text);
    callback(connector.CODE_SUCCEED);
};

TelegramSocial.prototype._getUserID = function () {
    return this.user.id;
};

TelegramSocial.prototype._aboutMe = function (callback) {
    callback(connector.CODE_SUCCEED, {
        id: this.user.id,
        name: this.user.first_name
    });
};

TelegramSocial.prototype.getAccessToken = function () {
    return "TELEGRAM";
};

TelegramSocial.formatUserData = function (userData) {
    return {
        id: "" + userData.id,
        name: userData.username,
        avatar: userData.photo_url
    };
};